// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import LiquorTree from 'liquor-tree';
import VueMoment from 'vue-moment';
import Vue2Filters from 'vue2-filters';
import moment from 'moment'
import rate from 'vue-rate';
import Brace from 'vue-bulma-brace'
Vue.prototype.moment = moment
import App from './App';
import router from './router';

Vue.config.productionTip = false;

const EventBus = new Vue();

Vue.prototype.$bus = EventBus;
Vue.use(rate)
Vue.use(Buefy, {
  defaultIconPack: 'fas'
});
Vue.use(LiquorTree);
Vue.use(VueMoment);
Vue.use(Vue2Filters);
Vue.use(Brace);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});

export default EventBus;



// WEBPACK FOOTER //
// ./src/main.js